import React from 'react';
import { Helmet } from 'react-helmet-async';
import { businessInfo, openingHours } from '../data/mock';

const SEOHead = () => {
  // LocalBusiness Schema JSON-LD
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "Locksmith",
    "name": businessInfo.fullName,
    "image": businessInfo.image,
    "telephone": businessInfo.phone,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "South Perth",
      "addressRegion": "WA",
      "addressCountry": "AU"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": -31.9786,
        "longitude": 115.8328
      },
      "geoRadius": "30000"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": businessInfo.rating.toString(),
      "reviewCount": businessInfo.reviewCount.toString()
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "07:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday", "Sunday"],
        "opens": "07:00",
        "closes": "13:00"
      }
    ],
    "priceRange": "$$",
    "url": window.location.href
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>South Perth Locksmith | DC Lock and Key | {businessInfo.phone}</title>
      <meta name="title" content={`South Perth Locksmith | DC Lock and Key | ${businessInfo.phone}`} />
      <meta
        name="description"
        content={`Trusted locksmith in South Perth. 5-star rated (${businessInfo.reviewCount} reviews). Residential & commercial lock services, key cutting, safe opening. Call ${businessInfo.phone} for prompt, professional service.`}
      />
      <meta name="keywords" content="locksmith South Perth, locksmith Perth, key cutting South Perth, lock repair Perth, safe opening Perth, commercial locksmith Perth, residential locksmith Perth" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="business.business" />
      <meta property="og:title" content={`South Perth Locksmith | DC Lock and Key`} />
      <meta
        property="og:description"
        content={`Trusted locksmith in South Perth. 5-star rated. Call ${businessInfo.phone} for prompt service.`}
      />
      <meta property="og:image" content={businessInfo.image} />
      <meta property="business:contact_data:phone_number" content={businessInfo.phone} />
      <meta property="business:contact_data:locality" content="South Perth" />
      <meta property="business:contact_data:region" content="WA" />
      <meta property="business:contact_data:country_name" content="Australia" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={`South Perth Locksmith | DC Lock and Key`} />
      <meta
        property="twitter:description"
        content={`Trusted locksmith in South Perth. 5-star rated. Call ${businessInfo.phone}`}
      />
      <meta property="twitter:image" content={businessInfo.image} />

      {/* Geo Tags */}
      <meta name="geo.region" content="AU-WA" />
      <meta name="geo.placename" content="South Perth" />
      <meta name="geo.position" content="-31.9786;115.8328" />
      <meta name="ICBM" content="-31.9786, 115.8328" />

      {/* Canonical */}
      <link rel="canonical" href={window.location.href} />

      {/* LocalBusiness Schema */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
